import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ShieldCheck } from "lucide-react";

export default function Affiliations() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/affiliations").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-16 bg-[#F9F8F6] border-y border-border" data-testid="affiliations-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 text-[#E07A5F]">
              <ShieldCheck className="w-4 h-4" />
              <span className="overline">Recognised By</span>
            </div>
            <h3 className="font-serif-display text-3xl text-[#1B4332] mt-3 leading-tight">
              Certifications &amp; Affiliations
            </h3>
            <p className="text-sm text-[#5C6661] mt-2 leading-relaxed">
              EDSW Foundation operates with the highest standards and is aligned with
              recognised national initiatives.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5" data-testid="affiliations-grid">
              {items.map((a, idx) => {
                const card = (
                  <div className="bg-white border border-border rounded-2xl p-5 flex flex-col items-center justify-center text-center h-full hover:border-[#E07A5F]/50 hover:-translate-y-0.5 transition-all">
                    <img src={a.logo} alt={a.name} className="w-20 h-20 object-contain" />
                    <div className="mt-3 text-xs font-semibold text-[#1B4332] uppercase tracking-wider leading-tight">
                      {a.short_name || a.name}
                    </div>
                  </div>
                );
                return a.link ? (
                  <a key={a.id} href={a.link} target="_blank" rel="noreferrer" data-testid={`affiliation-${idx}`}>{card}</a>
                ) : (
                  <div key={a.id} data-testid={`affiliation-${idx}`}>{card}</div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
